import styled from 'styled-components';

// Style
export const Wrapper = styled.div`
  padding: 64px 0 80px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 768px;
  height: 100%;
  margin: auto;
`;

export const Box = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  margin-bottom: 56px;
  font-size: 44px;
  font-weight: 700;
  text-align: center;
`;

export const IndicatorList = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-bottom: 40px;
`;

export const IndicatorItem = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  background-color: ${(props) => (props.$isActive === true ? '#0F0F0F' : '#E2E8F0')};
  border-radius: 50%;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => (props.$isActive === true ? '#fff' : '#64748B')};
`;

export const FormBox = styled.div`
  margin-bottom: 32px;
  padding: 24px 40px;
  background-color: #f1f2f6;
  border-radius: 8px;
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const Button = styled.button`
  width: ${(props) => (props.$isNotSingle ? 'calc(100% / 2)' : '100%')};
  height: 64px;
  background-color: ${(props) => (props.$secondary ? '#fff' : '#00A3A9')};
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => (props.$secondary ? '#00A3A9' : '#fff')};
  border-radius: 8px;
  border: ${(props) => props.$secondary && '1px solid #00A3A9'};
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$secondary ? '#e6f7f8' : '#008489')};
    border-color: ${(props) => props.$secondary && '#008489'};
    color: ${(props) => (props.$secondary ? '#008489' : '#fff')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: ${(props) => (props.$secondary ? '#fff' : '#00A3A9')};
    border-color: ${(props) => props.$secondary && '#00A3A9'};
    color: ${(props) => (props.$secondary ? '#00A3A9' : '#fff')};
  }
`;
export const AttachmentBox = styled.div`
  & .attachment_btn {
    & label {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 95px;
      height: 56px;
      background-color: #2e3b4d;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 0.2s ease, opacity 0.2s ease;

      &:hover {
        background-color: #223042;
      }
    }
    & input {
      position: absolute;
      overflow: hidden;
      width: 0;
      height: 0;
      padding: 0;
      border: 0;
    }
  }
  & .attachment_name {
    width: calc(100% - 105px);
    & .name_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      width: 100%;
      height: 56px;
      padding: 16px;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      & .name_text {
        line-height: 1.6;
      }
      & .remove {
        width: 20px;
        height: 20px;
        cursor: pointer;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
  & .guide_desc {
    font-size: 16px;
    color: #767676;
  }
`;
export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.$gap};
  margin: ${(props) => props.$margin};
`;
